import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    onClick: _ctx.onClick,
    clickable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, { avatar: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, { name: _ctx.icon }, null, 8, ["name"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, { avatar: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "open_in_new" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClick"]))
}